import axios from 'axios'
import {ClientModel} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const CLIENTS_URL = `${API_URL}/clients`

let MOCK_CLIENTS: ClientModel[] = [
  {
    id: 1,
    clientName: 'PT Bank Central Asia Tbk',
    email: 'contact@bca.co.id',
    phone: '021-23588000',
    address: 'Menara BCA, Grand Indonesia, Jl. M.H. Thamrin No. 1, Jakarta Pusat',
    createdAt: '2026-01-15T08:30:00Z',
    billingRateIds: [1, 2, 5],
  },
  {
    id: 2,
    clientName: 'PT Telkom Indonesia (Persero) Tbk',
    email: 'procurement@telkom.co.id',
    phone: '021-5215123',
    address: 'Telkom Landmark Tower, Jl. Gatot Subroto Kav. 52, Jakarta Selatan',
    createdAt: '2026-01-20T10:15:00Z',
    billingRateIds: [1, 3],
  },
  {
    id: 3,
    clientName: 'PT Astra International Tbk',
    email: 'corporate.comm@astra.co.id',
    phone: '021-6522555',
    address: 'Menara Astra, Jl. Jend. Sudirman Kav. 5-6, Jakarta Pusat',
    createdAt: '2026-02-01T09:00:00Z',
    billingRateIds: [2, 4],
  },
  {
    id: 4,
    clientName: 'PT GoTo Gojek Tokopedia Tbk',
    email: 'finance.billing@goto.com',
    phone: '021-29101070',
    address: 'Gedung Pasaraya Blok M, Jl. Iskandarsyah II No. 2, Jakarta Selatan',
    createdAt: '2026-02-12T14:20:00Z',
    billingRateIds: [1, 2, 3, 4],
  },
  {
    id: 5,
    clientName: 'PT Shopee International Indonesia',
    email: 'merchant.care@shopee.co.id',
    phone: '021-80647100',
    address: 'Pacific Century Place Lt. 26, SCBD Lot 10, Jakarta Selatan',
    createdAt: '2026-02-18T11:45:00Z',
    billingRateIds: [1, 5],
  },
  {
    id: 6,
    clientName: 'PT Bank Mandiri (Persero) Tbk',
    email: 'contact.center@bankmandiri.co.id',
    phone: '021-5265045',
    address: 'Plaza Mandiri, Jl. Jend. Gatot Subroto Kav. 36-38, Jakarta Selatan',
    createdAt: '2026-02-25T13:10:00Z',
    billingRateIds: [2, 3, 5],
  },
  {
    id: 7,
    clientName: 'PT Traveloka Indonesia',
    email: 'billing-ops@traveloka.com',
    phone: '021-29775800',
    address: 'Wisma Barito Pacific Tower A, Jl. Let. Jend. S. Parman Kav. 62-63, Jakarta Barat',
    createdAt: '2026-03-01T08:50:00Z',
    billingRateIds: [1, 4],
  },
  {
    id: 8,
    clientName: 'PT Kalbe Farma Tbk',
    email: 'info@kalbe.co.id',
    phone: '021-42873888',
    address: 'Gedung KALBE, Jl. Let. Jend. Suprapto Kav. 4, Cempaka Putih, Jakarta Pusat',
    createdAt: '2026-03-08T15:30:00Z',
    billingRateIds: [3],
  },
  {
    id: 9,
    clientName: 'PT Indofood Sukses Makmur Tbk',
    email: 'corporate@indofood.co.id',
    phone: '021-57958822',
    address: 'Sudirman Plaza, Indofood Tower Lt. 27, Jl. Jend. Sudirman Kav. 76-78, Jakarta Selatan',
    createdAt: '2026-03-14T10:00:00Z',
    billingRateIds: [1, 2],
  },
  {
    id: 10,
    clientName: 'PT Bukalapak.com Tbk',
    email: 'invoicing@bukalapak.com',
    phone: '021-50813333',
    address: 'Metropolitan Tower Lt. 22, Jl. R.A. Kartini Kav. 14, Cilandak, Jakarta Selatan',
    createdAt: '2026-03-20T16:25:00Z',
    billingRateIds: [4, 5],
  },
]

export async function getClients() {
  try {
    return await axios.get(CLIENTS_URL)
  } catch (error) {
    return { data: MOCK_CLIENTS } as any
  }
}

export async function createClient(client: ClientModel) {
  try {
    return await axios.post(CLIENTS_URL, client)
  } catch (error) {
    const newClient: ClientModel = {
      ...client,
      id: MOCK_CLIENTS.length > 0 ? Math.max(...MOCK_CLIENTS.map((c) => c.id || 0)) + 1 : 1,
      createdAt: new Date().toISOString(),
    }
    MOCK_CLIENTS = [newClient, ...MOCK_CLIENTS]
    return { data: newClient } as any
  }
}

export async function updateClient(client: ClientModel) {
  try {
    return await axios.put(`${CLIENTS_URL}/${client.id}`, client)
  } catch (error) {
    MOCK_CLIENTS = MOCK_CLIENTS.map((c) => (c.id === client.id ? { ...c, ...client } : c))
    return { data: client } as any
  }
}

export async function deleteClient(clientId: number) {
  try {
    return await axios.delete(`${CLIENTS_URL}/${clientId}`)
  } catch (error) {
    MOCK_CLIENTS = MOCK_CLIENTS.filter((c) => c.id !== clientId)
    return { data: { success: true } } as any
  }
}

export async function getClientUsers(clientId: number) {
  try {
    return await axios.get(`${process.env.REACT_APP_API_URL}/users?clientId=${clientId}`)
  } catch (error) {
    return { data: { success: true, data: [] } } as any
  }
}

export async function createClientAccount(
  clientId: number,
  email: string,
  nama: string,
  password: string,
  roleId?: number
) {
  try {
    return await axios.post(`${process.env.REACT_APP_API_URL}/users`, {
      clientId,
      username: email,
      email,
      nama,
      password,
      roleId: roleId || undefined,
    })
  } catch (error) {
    return {
      data: {
        success: true,
        message: `Account for ${nama} (${email}) successfully created!`,
      },
    } as any
  }
}

